import { Card, Form } from "antd";
import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../admin/pageHeader/pageheader";

function MonthlyReport() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // Define the page size
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Fetching data for clients
  const fetchHrClient = async (page: number, take: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query"),
        page,
        take,
      };
      const url = API.PAGENATION_CLIENT;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log("Error fetching clients:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHrClient(page, pageSize);
  }, [page, pageSize]);

  return (
    <div>
      <PageHeader />
      <h1>Clients Details</h1>
      <Card>
        {" "}
        <div className="grid-container">
          {data?.length > 0 ? (
            data.map((client: any, index: number) => (
              <Card
                className="inner-card"
                key={index}
                onClick={() =>
                  navigate(`/Hr/MonthlyReport/Report/${client.id}`)
                }
              >
                <h6>{client.companyName}</h6>
              </Card>
            ))
          ) : (
            <p style={{ textAlign: "center", margin: "20px auto" }}>
              No clients available
            </p>
          )}
        </div>
      </Card>
    </div>
  );
}

export default MonthlyReport;
